import * as React from 'react';
import { v4 as uuidv4 } from 'uuid';

interface SwitcherProps {
    options: Array<string>;
    selectedOption: number;
    option_onClick: (index: number) => void;
}

interface SwitcherState {
    Id: string,
    selectorWidth: number
}

export default class Switcher extends React.PureComponent<SwitcherProps, SwitcherState> {

    constructor(props: SwitcherProps) {
        super(props)
        this.state = {
            Id: uuidv4(),
            selectorWidth: 0
        }
        this.onResize = this.onResize.bind(this);
    }

    onResize() {
        var selectorWidth = (document.getElementById(this.state.Id)?.offsetWidth as number - 4) / this.props.options.length;
        this.setState({ selectorWidth: selectorWidth })
    }

    componentDidMount(): void {
        this.onResize();
        window.addEventListener('resize', this.onResize)
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', this.onResize)
    }

    public render() {

        return (
            <div className='switcher' id={this.state.Id}>
                {this.props.options.map((element, index) =>
                    <div className='switcher__option swither-text' key={index}
                        onClick={() => this.props.option_onClick(index)}>
                        <span style={{ cursor: this.props.selectedOption === index ? "default" : "pointer" }}>{element}</span>
                    </div>
                )}

                <div className='switcher__selector'
                    style={{
                        width: this.state.selectorWidth,
                        left: this.props.selectedOption * this.state.selectorWidth + 2
                    }}
                />
            </div>
        );
    }
}